import { Divider, Stack, Text, Title, useMantineTheme } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import confetti from 'canvas-confetti'
import React, { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { saveLocation } from '@/plugins/auth/RouteRedirectors/utils'

import RootButton from '../Buttons/RootButton'

const CompletedAirdrop: React.FC = () => {
  const theme = useMantineTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  useEffect(() => {
    confetti({
      particleCount: 1550,
      spread: 1400,
    })
    // launch a few confetti from the left edge
    confetti({
      particleCount: 117,
      angle: 60,
      spread: 55,
      origin: { x: 0 },
    })
    // and launch a few from the right edge
    confetti({
      particleCount: 117,
      angle: 120,
      spread: 55,
      origin: { x: 1 },
    })
  }, [])

  const handleNavigation = useCallback(() => {
    saveLocation('/wallet')
    navigate('/wallet')
  }, [navigate])

  return (
    <Stack style={{ gap: 40 }}>
      <Divider />

      <Stack style={{ gap: '20px' }}>
        <Title order={isMobile ? 3 : 2}>
          {t('components.airdrop.completed', 'Claim Successful')}
        </Title>
        <Text style={{ fontSize: 14 }}>
          {t(
            'components.airdrop.completedDescription',
            'Nice work! You have successfully claimed your airdrop. Go to your “Wallet” tab to see the transaction and to see the LL1 you’ll be able to unwrap over time.'
          )}
        </Text>
        <RootButton onClick={handleNavigation}>{t('buttons.openWallet', 'Open Wallet')}</RootButton>
      </Stack>
    </Stack>
  )
}
export default CompletedAirdrop
